import { Button } from "reactstrap"
import { getDaysDiff } from "../../utility/Utils"
import './NavLead.scss'
import moment from "moment"
import { useSelector } from "react-redux"
export default function NavLead() {
  const userState = useSelector((state) => state.auth.userData)

  const date = new Date()
  const daysDiff = getDaysDiff(moment(date).format('DD/MM/YYYY'), userState.user.venda_expired_at.split('-').reverse().join('/'))

  return (
    <div className="container-nav-lead d-flex  align-items-center gap-1 justify-content-center">
      <span className="text-white">Seu período de teste grátis termina {daysDiff === 0 ? "hoje!" : `${daysDiff} dia(s)`}. </span>
      <a href="https://wa.me/5596988084271?text=Ol%C3%A1+quero+ter+mais+informa%C3%A7%C3%B5es+sobre+o+Tributei" target="_blank" rel="noopener noreferrer">
        <Button className="border-0 background-gradiente">
          Contratar um plano
        </Button>
      </a>
    </div>
  )
}